<template>
	<Dropdown
		ref="dropdown"
		:value="value"
		:options="options"
		:disabled="disabled"
		:is-small="true"
		@input="setSelected"
	>
		<template #selected-item>
			<div class="selected-item">
				<div class="value-label">
					{{ selectedLabel }}
				</div>
				<div class="value-icon">
					<Icon
						v-if="hasIcon(value)"
						size="sm"
						:inline="false"
						:icon-name="icons[value.id]"
					/>
				</div>
			</div>
		</template>
		<template #item-list="{ option }">
			{{ option.label }}
			<Icon
				v-if="icons[option.id]"
				:icon-name="icons[option.id]"
				size="sm"
			/>
		</template>
		<template #list-footer>
			<slot name="list-footer" />
		</template>
	</Dropdown>
</template>

<script>
import Dropdown from '@components/dropdown/Dropdown';

export default {
	name:       'DropdownWithIcons',
	components: { Dropdown },
	props:      {
		options: {
			type:    Array,
			default: () => [],
		},
		value: {
			type:    [String, Number, Object],
			default: null,
		},
		disabled: {
			type:    Boolean,
			default: false,
		},
	},
	data() {
		return {
			userSelectedOption: null,
		};
	},
	computed: {
		selectedLabel() {
			return this.value?.label ?? this.dropdownTrans.NO_SELECTION;
		},
		icons() {
			return this.options.reduce((acc, option) => {
				return { ...acc, [option.id]: option.icon };
			}, {});
		},
	},
	methods: {
		hasIcon(option) {
			return option?.icon;
		},
		setSelected(value) {
			this.$emit('input', value);
		},
		closeDropdown() {
			this.$refs.dropdown.closeDropdown();
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';

.dropdown {
	.selected-item {
		display: flex;
		align-items: center;
		flex: 1;
		max-width: calc(100% - 32px);

		.value-label {
			flex-shrink: 1;
			margin-right: 8px;
			max-width: initial;
		}

		.value-icon {
			color: var(--color-grey-300);
		}
	}

	&.disabled {
		.selected-item .value-icon {
			color: var(--color-grey-700);
		}
	}

	::v-deep ul.dropdown-list li {
		padding-right: 12px;
	}
}
</style>
